import React from "react";
import InputField from "../../../common/components/FormFields/InputField";
import { useForm, useFormContext } from "react-hook-form";
import InputArea from "../../../common/components/FormFields/InputArea";

export default function GynacPastHistory(props) {
  const {
    control,
    watch,
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useFormContext({
    mode: "onChange",
    // defaultValues,
  });
  return (
    <div>
      <div>
        <div className="flex justify-between bg-[#CFFAFE] rounded-t-md">
          <p className="text-sm font-semibold pl-2 py-1">Past History</p>
        </div>
        <div className="grid grid-cols-2 overflow-auto gap-2 border px-2 py-2 h-64 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">


          <div className="">
            <InputArea control={control} name="DM" label="DM" disabled={props.pastData !== null} />
          </div>

          <div className="">
            <InputArea control={control} name="HTN" label="HTN" disabled={props.pastData !== null} />
          </div>
          <div className="">
            <InputArea
              control={control}
              name="heartDisease"
              label="Heart Disease"
              disabled={props.pastData !== null}
            />
          </div>

          <div className="">
            <InputArea
              control={control}
              name="surgicalHistory"
              label="Surgical History"
              disabled={props.pastData !== null}
            />
          </div>

          <div className="">
            <InputArea
              control={control}
              name="familyHistory"
              label="Family History"
              disabled={props.pastData !== null}
            />
          </div>

          <div className="">
            <InputArea
              control={control}
              name="pastOtherHistory"
              label="Other History"
              disabled={props.pastData !== null}
            />
          </div>
        </div>
      </div>
    </div>

  );
}
